export const isScheduleTree = (type?: string): boolean => type === 'ScheduleTree';
